import * as tslib_1 from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import PageHeader from '../components/Header.vue';
import PageFooter from '../components/Footer.vue';
let app = class app extends Vue {
    constructor() {
        super(...arguments);
        this.flagHeaderShow = true;
        this.flagFooterShow = true;
        this.aboutDisplay = true;
    }
    onRouteChanged(_val, _oldVal) {
        if (this.$router.currentRoute.name === 'about') {
            this.aboutDisplay = false;
        }
        else {
            this.aboutDisplay = true;
        }
    }
};
tslib_1.__decorate([
    Watch('$route')
], app.prototype, "onRouteChanged", null);
app = tslib_1.__decorate([
    Component({
        name: 'app',
        components: {
            'page-header': PageHeader,
            'page-footer': PageFooter
        }
    })
], app);
export default app;
